export default __webpack_public_path__ + "static/media/Rerebrace of Red Ruin.3720decb.jpg";